import {
  Edit,
  SimpleForm,
  TextInput,
  usePermissions,
  useNotify,
} from "react-admin";

const FormEdit = (props) => {
  const { permissions = [] } = usePermissions();
  const notify = useNotify();

  if (
    !(
      permissions.includes("forms.edit") ||
      permissions.includes("forms.*") ||
      permissions.includes("*")
    )
  ) {
    return null;
  }

  return (
    <Edit title="Edit Feedback Form" {...props} redirect="list">
      <SimpleForm
        onSuccess={() =>
          notify("Form updated successfully", { type: "success" })
        }
      >
        <TextInput source="title" />
        <TextInput source="description" />
      </SimpleForm>
    </Edit>
  );
};

export default FormEdit;